document.addEventListener('DOMContentLoaded', function () {

  // Restricted pincode prefixes
  const restrictedPrefixes = [
    '18', '19',             // Jammu & Kashmir (180xxx–193xxx)
    '79',                   // Assam (781xxx–788xxx) — starts with 79
    '78',                   // Assam (780xxx)
    '737', '736', '735',    // West Bengal hills / Sikkim border
    '744', '743',           // Andaman & Nicobar
    '796', '797', '798',    // Mizoram
    '793', '794', '795',    // Meghalaya
    '781', '782', '783',    // Assam
    '784', '785', '786', '787', '788', // Assam / Nagaland
    '790', '791', '792',    // Arunachal Pradesh
    '799',                  // Tripura
    '700',                  // Kolkata (keep if you deliver here, remove if not)
  ];

  const nonServiceableMessage = `
    <span style="color:red;">
      ❌ Sorry, we currently do not deliver to <strong>Jammu & Kashmir</strong> 
      and <strong>North East India</strong>.
    </span>
  `;

  function isRestricted(pincode) {
    return restrictedPrefixes.some(function (prefix) {
      return pincode.startsWith(prefix);
    });
  }

  function getEstimatedDate(businessDays) {
    const cutoffHour = 14;
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const ist = new Date(now.getTime() + istOffset);

    if (ist.getHours() >= cutoffHour) businessDays++;

    function addBusinessDays(date, days) {
      let count = 0;
      while (count < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) count++;
      }
      return date;
    }

    const deliveryDate = addBusinessDays(new Date(ist), businessDays);
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return deliveryDate.toLocaleDateString('en-IN', options);
  }

  function isValidPincode(pincode) {
    return /^\d{6}$/.test(pincode);
  }

  const btn = document.getElementById('check-pincode-btn');
  const resultDiv = document.getElementById('delivery-result');
  const input = document.getElementById('delivery-pincode');

  if (btn) {
    btn.addEventListener('click', function () {
      const pincode = input.value.trim();

      // Validate format
      if (!isValidPincode(pincode)) {
        resultDiv.style.display = 'block';
        resultDiv.innerHTML = `<span style="color:red;">⚠️ Please enter a valid 6-digit PIN code.</span>`;
        return;
      }

      // Check restricted zones
      if (isRestricted(pincode)) {
        resultDiv.style.display = 'block';
        resultDiv.innerHTML = nonServiceableMessage;
        return;
      }

      // Serviceable — show delivery date
      const deliveryDate = getEstimatedDate(7);
      resultDiv.style.display = 'block';
      resultDiv.innerHTML = `
        ✅ Delivery to <strong>${pincode}</strong> by<br>
        🚚 <strong>${deliveryDate}</strong> (7 working days)
      `;

      localStorage.setItem('delivery_pincode', pincode);
    });

    // Auto-fill last used pincode
    const saved = localStorage.getItem('delivery_pincode');
    if (saved) {
      input.value = saved;
      btn.click();
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const reviews = [
    { text: "Absolutely love my personalized gift! Quality is amazing and delivery was on time.", name: "— Priya S., Delhi" },
    { text: "Ordered a custom mug for my friend's birthday. It looked exactly like the preview!", name: "— Rahul M., Mumbai" },
    { text: "Super smooth experience. Will definitely order again from Customfy!", name: "— Anjali K., Bangalore" }
  ];

  const toast = document.getElementById('review-toast');
  const closeBtn = document.getElementById('review-toast-close');
  const reviewText = document.getElementById('toast-review-text');
  const reviewerName = document.getElementById('toast-reviewer-name');
  const dots = document.querySelectorAll('.toast-dot');

  if (!toast) return;

  const hasVisited = localStorage.getItem('has_visited_review');
  if (hasVisited) return; // Don't show to returning visitors

  let currentIndex = 0;
  let autoSlideInterval;

  function showReview(index) {
    // Slide out
    toast.classList.add('toast-slide-out');

    setTimeout(function () {
      reviewText.textContent = reviews[index].text;
      reviewerName.textContent = reviews[index].name;

      // Update dots
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === index);
      });

      // Slide in
      toast.classList.remove('toast-slide-out');
      toast.classList.add('toast-slide-in');

      setTimeout(function () {
        toast.classList.remove('toast-slide-in');
      }, 400);
    }, 300);
  }

  function startAutoSlide() {
    autoSlideInterval = setInterval(function () {
      currentIndex = (currentIndex + 1) % reviews.length;
      showReview(currentIndex);
    }, 4000); // Change every 4 seconds
  }

  // Initial load
  setTimeout(function () {
    showReview(0);
    toast.style.display = 'block';
    startAutoSlide();
  }, 3000); // Appear after 3 seconds

  // Close button
  closeBtn.addEventListener('click', function () {
    toast.style.display = 'none';
    clearInterval(autoSlideInterval);
    localStorage.setItem('has_visited_review', 'true');
  });
});

